export default "__VITE_ASSET__uN0PVWhV__"